import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BailModel } from './bail.model';
import { BailService } from './bail.service';
import { AccountsAndTaxesModel } from '../../invoice/preinvoice/accountsandtaxes.model';
import { PreinvoiceService } from '../../invoice/preinvoice/preinvoice.service';
import { BailLineModel } from './bail-line.model';
import { ConceptService } from '../../concept/concept/concept.service';
import { ConceptModel } from '../../concept/concept/concept.model';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { PaymentCardModel } from '../../finanzas/paymentcard/paymentcard.model';
import { PaymentCardService } from '../../finanzas/paymentcard/paymentcard.service';
import { BankAccountService } from '../../finanzas/bancos/bankaccount.service';

@Component({
    selector: 'convfact-bail',
    templateUrl: './bail.component.html',
    styleUrls: ['./bail.component.css'],
    standalone: false
})
export class BailComponent implements OnInit {
  bail = new BailModel();
  errors = {};
  accountsAndTaxes = new AccountsAndTaxesModel();
  ready: boolean = false;
  concepts: ConceptModel[] = [];
  bankAccounts: BankAccountModel[] = [];
  paymentCards: PaymentCardModel[] = [];

  submit(): void {}

  constructor(
    private bailService: BailService,
    private preinvoiceService: PreinvoiceService,
    private route: ActivatedRoute,
    private conceptService: ConceptService,
    private router: Router,
    private paymentCardService: PaymentCardService,
    private bankAccountService: BankAccountService
  ) {}

  saveData = (bail): void => {
    this.ready = false;
    if (bail.uid == null) {
      this.bailService.addData(bail)
        .then(response => {
          this.bail = response;
          this.ready = false;
          this.returnToIndex();
        })
        .catch(errors => this.errors = JSON.parse(errors['error'])['data']);
    } else {
      this.bailService.editData(bail.uid, bail)
        .then(response => {
          this.bail = response;
          this.ready = false;
          this.returnToIndex();
        })
        .catch(errors => this.errors = JSON.parse(errors['error'])['data']);
    }
  };

  ngOnInit(): void {
    this.bail.bailLine = new Array<BailLineModel>();

    this.preinvoiceService.accountsAndTaxesData().then(accountsAndTaxes => {
      this.accountsAndTaxes = accountsAndTaxes;
      this.conceptService.getList().then(response => {
        this.concepts = response;
        this.ready = true;
      });
    });

    this.route.params.subscribe(params => {
      const uid = params['uid'];
      if (uid !== undefined) {
        this.bailService.loadData(uid).then(response => {
          this.bail = response;
          this.ready = true;
        });
      }
    });

    this.bankAccountService.getList().then(bankAccounts => {
      this.bankAccounts = bankAccounts.list;

      this.paymentCardService.getList(0).then(paymentCards => {
        this.paymentCards = paymentCards.list;
        this.ready = true;
      });
    });
  }

  returnToIndex = (): void => {
    this.router.navigate(['/expense/advancepayment/bail']);
  };
}